import { ReactElement } from 'react';
import { SessionColor, getSessionColorHex } from '../hooks/useSessionColor';

const STORAGE_KEY = 'sessionColors';

// Read color directly from localStorage (for components that don't need reactivity)
const getStoredSessionColor = (sessionId: string): SessionColor => {
  if (typeof window === 'undefined') return null;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const colors = stored ? JSON.parse(stored) : {};
    return colors[sessionId] || null;
  } catch {
    return null;
  }
};

interface SessionColorIndicatorProps {
  sessionId: string;
  className?: string;
}

export default function SessionColorIndicator({ sessionId, className = '' }: SessionColorIndicatorProps): ReactElement | null {
  const color = getStoredSessionColor(sessionId);

  if (!color) return null;

  const colorHex = getSessionColorHex(color);

  return (
    <div
      className={`cr-absolute cr-bottom-2 cr-right-2 cr-h-4 cr-w-4 cr-rounded-full ${className}`}
      style={{ backgroundColor: colorHex }}
    />
  );
}
